import Template from './Template';
import Manage from './Manage';

export default {
	Template,
	Manage
};
